module.exports = __webpack_public_path__ + "fonts/Noto_Sans_SC-300-100.1ee56aa.woff2";